import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { installIssueDiagnostics } from "@/lib/issue-diagnostics";
import { router } from "./router";
import "./index.css";

// Keeps the last console errors and API calls so a reported Issue can carry them.
installIssueDiagnostics();

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);

if (import.meta.hot) {
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  createRoot(elem).render(app);
}
